// TODO: write documentation for colors and palette in own markdown file and add links from here

const palette = {
	primary: '#607EFE',
	primaryActive: '#3a58d0',
	primaryHover: '#92a6fe',
	colorBorder: '#D9D9D9',
	colorBgContainerDisabled: '#F2F2F2',
	colorTextDisabled: '#222222',
	secondary: '#4a64d8',
	white: '#FFFFFF',
	black: '#000000',
	rhino: '#3B476B',
	font1: '#111111',
	font2: '#222222',
	font3: '#333333',
	red7: '#FF0000',
	blue6: '#EFF2FF',
} as const;

const menu = {
	subMenuItemBg: '#212C57',
	menuItemColorHover: '#609AFE',
	menuItemBgHover: '#161F43',
	menuItemSelectedBg: '#161F43',
};

export const Colors = {
	/**
	 * The palette is available to use, but prefer using the name.
	 * This is only included for rare, one-off cases. Try to use
	 * semantic names as much as possible.
	 */
	palette,
	/**
	 * A helper for making something see-thru.
	 */
	transparent: 'rgba(0, 0, 0, 0)',
	/**
	 * The default text color in many components.
	 */
	textPrimary: palette.primary,

	menu,
};

export const Font = {
	pretendard: 'Pretendard',
};
